import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { bool, func, node, object, shape, string } from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { PermissionGate } from '..';
import { Wrapper } from './styles';

export const Link = ({
  disabled, to, onClick, children,
}) => (
  <RouterLink
    className={`button-link ${disabled ? 'disabled' : ''}`}
    to={to}
    onClick={disabled ? undefined : onClick}
    aria-disabled={disabled}
    tabIndex={disabled ? -1 : 0}
  >
    {children}
  </RouterLink>
);

const EmptyList = ({
  text,
  additionalTexts,
  cta,
  upgradeCta,
  dashboardPermission,
  wrapperStyles,
}) => {
  const theme = useTheme();

  return (
    <Wrapper wrapperStyles={wrapperStyles}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{ '& > img': { height: '100px', marginBottom: theme.spacing(2) } }}
        gap={3}
      >
        <img src="/assets/images/rocket.png" alt="" />
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="bold" component="p">{text}</Typography>
          {additionalTexts}
        </Box>
        {upgradeCta}
        {(cta && !upgradeCta) && (
          <Box sx={{ display: 'flex' }}>
            <PermissionGate dashboardPermission={dashboardPermission} disabled>
              {cta.path ? (
                <Link to={cta.path} onClick={cta.onClick}>{cta.text}</Link>
              ) : (
                <Button
                  variant="outlined"
                  onClick={cta.onClick}
                >
                  {cta.text}
                </Button>
              )}
            </PermissionGate>
          </Box>
        )}
      </Box>
    </Wrapper>
  );
};

export default EmptyList;

EmptyList.propTypes = {
  text: string.isRequired,
  additionalTexts: node,
  cta: shape({
    text: string.isRequired,
    path: string,
    onClick: func.isRequired,
  }),
  upgradeCta: node,
  dashboardPermission: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  wrapperStyles: object,
};

EmptyList.defaultProps = {
  cta: null,
  upgradeCta: null,
  wrapperStyles: {},
  additionalTexts: null,
};

Link.propTypes = {
  disabled: bool,
  to: string.isRequired,
  onClick: func.isRequired,
  children: node.isRequired,
};

Link.defaultProps = {
  disabled: false,
};
